<script lang="ts">
	import DocumentTitle from '$lib/DocumentTitle.svelte';
	import SourceBadge from '$lib/SourceBadge.svelte';
	import type { CitationAttrs } from '$lib/markdown/types';
	import { tooltip } from '$lib/tooltip/tootlip.svelte';
	import { getChatContext } from 'src/contexts/chat.context.svelte';

	interface Props extends CitationAttrs {
		onRefClick?: (attrs: CitationAttrs) => void;
	}

	let { chunkId, docId, webId, quote, hash, onRefClick }: Props = $props();

	const chatCtx = getChatContext();
	const info = $derived(chatCtx.getCitationInfo(hash));
	const isWeb = $derived(webId != null);
	const attrs = $derived<CitationAttrs>({ hash, chunkId, docId, webId, quote });

	const tooltipDoc = $derived.by(() => {
		if (!info) {
			return undefined;
		}
		const { source } = info;
		if (source.web_id != null) {
			return source;
		}
		return source.doc_id != null ? chatCtx.documentMap.get(source.doc_id) : undefined;
	});
</script>

{#if info}
	{@const { source, occurrence } = info}
	{#snippet docTitle()}{#if tooltipDoc}<DocumentTitle doc={tooltipDoc} />{/if}{/snippet}
	<div
		use:tooltip={tooltipDoc ? docTitle : undefined}
		role="button"
		tabindex="0"
		onclick={() => onRefClick?.(attrs)}
		onkeydown={(e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				onRefClick?.(attrs);
			}
		}}
	>
		<SourceBadge
			badge={{
				color: source.citation_color,
				index: source.citation_index,
				subIndex: occurrence.sub_index
			}}
			webSource={isWeb}
		/>
	</div>
{/if}

<style lang="scss">
	div {
		display: inline;
		cursor: pointer;
	}
</style>
